
import actions from './actions/frontendAppSettings';
import getters from './getters/frontendAppSettings';
import mutations from './mutations/frontendAppSettings';

const getBaseState = () => {
	return {
		settings: {},
	}
}

const state = getBaseState();

export {
	getBaseState,
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
}